import _ from 'lodash'

import { getDeferredUser } from './utils'

export type Recipient = any

const cloneRecipient = (recipient: Recipient): Recipient => {
  return _.isString(recipient) ? recipient : _.cloneDeep(recipient)
}

export const getShareRecipient = (share: any): Recipient | undefined => {
  const sharedTo = _.get(share, 'share.sharedTo')
  if (!sharedTo) {
    return
  }
  return cloneRecipient(sharedTo)
}

export const recipientKey = (recipient: Recipient): string => {
  if (!recipient) {
    return ''
  }
  if (_.isString(recipient)) {
    return recipient
  }
  const phone = recipient?.phoneNumber?.phone
  const normalizedEmail = recipient?.email ? _.toLower(recipient.email) : undefined
  const userId = recipient?.user?.entityId
  const uniqueId = recipient?.uniqueId
  const key = phone ?? normalizedEmail ?? userId ?? uniqueId

  if (key) {
    return key
  }
  try {
    return JSON.stringify(recipient)
  } catch {
    return String(recipient)
  }
}

export const shareKey = (share: any): string => recipientKey(getShareRecipient(share))

export const toDeferredContact = (recipient: Recipient): Recipient => {
  if (_.isString(recipient)) {
    return getDeferredUser(recipient)
  }
  return recipient
}
